import styled from 'styled-components';

export default styled.div`
	margin-bottom: 10px;
	.cloud-wrapper {
		display: flex;
		align-items: center;
		padding: 1rem;

		.cloud-icon {
			margin: 0rem 0.5rem;
			width: 3rem;
		}
	}

	.desc-container {
		position: relative;

		min-height: 50px;
		padding: 24px 75px;
		padding-right: 60px;
		.anticon {
			position: absolute;
			left: 15px;
			top: 55px;
			border-radius: 50%;
			border: 1px solid #b9b9b9;
			display: block;
			width: 45px;
			height: 45px;
		}
		p {
			font-style: italic;
			line-height: 1.8rem;
		}
		.download {
			color: #00f;
			cursor: pointer;
			text-decoration: underline;
		}
	}
	.disclamar {
		font-size: 12px;
		color: #545454;
		padding-top: 15px;
		text-align: center;
		p {
			line-height: 1;
		}
	}
	.talking-bubble {
		border: 1px solid #D6D6D6;
		border-radius: 25px;
		background-color: #ECECEC;
		padding: 10px;
		margin-bottom: 10px;

		b {
			font-size: 14px;
		}
	}
	.talking-bubble:before {
		content: "";
		width: 0;
		height: 0;
		border-top: 16px solid transparent;
		border-bottom: 16px solid transparent;
		border-right: 12px solid #D6D6D6;
		position: absolute;
		left: 65px;
		top: 64px;
	}
	.talking-bubble:after {
		content: "";
		width: 0;
		height: 0;
		border-top: 25px solid transparent;
		border-bottom: 24px solid transparent;
		border-right: 20px solid #ECECEC;
		position: absolute;
		left: 66px;
		top: 55px;
	}
`;
